import { render, staticRenderFns } from "./BottomNavigationSetting.vue?vue&type=template&id=6126608a&"
import script from "./BottomNavigationSetting.vue?vue&type=script&lang=js&"
export * from "./BottomNavigationSetting.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigationSetting.vue?vue&type=style&index=0&id=6126608a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports